var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:_vm.$style.gallery},_vm._l((_vm.data),function(ref,key){
var image = ref.image;
return _c('li',{key:key,class:_vm.$style.item},[_c('Img',{class:_vm.$style.image,attrs:{"data":image,"width":318,"height":318}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }